module.exports = __webpack_public_path__ + "static/img4-93cc7d3c9b15a4717faf2e441ac7d0f3.png";